import { api, unwrap, type APIResponse } from "./client";

/** One rep's row on the performance board.
 *
 * Note the vocabulary: OFFERED and TAKEN, not "dials". The dialer dials and
 * hands the agent a live person, so a per-agent dial count would be a number
 * with nothing behind it. Offered/taken answers what a manager actually asks:
 * when we reach you, do you pick up?
 */
export interface ScoreRow {
  agent_name: string;
  extension_id: number | null;
  extension_name: string | null;
  team: string | null;
  logged_s: number;
  talk_s: number;
  offered: number;
  taken: number;
  contact_rate: number;
  transfers: number;
  transfers_merged: number;
  /** Transfers per hour on shift. */
  tph: number;
  /** Transfers per day worked. */
  tpd: number;
  avg_talk_s: number;
  over_2m: number;
  over_20m: number;
  dispositions: number;
  dispo_integrity: number;
  grade: string;
  status: string;
}

export interface Scorecard {
  rows: ScoreRow[];
  totals: ScoreRow | null;
  meta: { timezone: string; date_from: string; date_to: string };
  generated_at: string;
}

export async function getScorecard(params?: {
  date_from?: string;
  date_to?: string;
}): Promise<Scorecard> {
  const resp = await api.get<APIResponse<Scorecard>>("/workforce/scorecard", {
    params,
  });
  return unwrap(resp.data);
}
